/**
 * 由于有很多种code的情况需要处理
 * 统一处理code的逻辑
 */
import React from 'react';
import { Toast } from 'antd-mobile';
import history from 'commons/History';
// import globalCanViews from 'api/Constant';
import store from 'api/Store';
import { gotoLogin, gotoBindMobile } from './Login';
import { urlAddFrom } from './Helper';
import { Alert } from 'commons/Modal';
import { is58App } from 'api/Helper';


let isShowTipLayer = false;
const handleResponseCode = (res) => {
    const pathName = history.location.pathname;
    // code不为1的时候缓存code
    if (res.code !== 1) store.set('RESPONSESTATUSCODE', res.code - 0);
    // 下边的if暂时先注释掉，因为忘了当时为什么要加这段代码，造成了在globalCanViews的页面下，请求异常信息不提示了
    // if (globalCanViews(pathName) || pathName.indexOf('/faq/') === 0) {
    //     return res;
    // }
    switch (res.code) {
        // 未登录
        case 2:
            gotoLogin();
            break;
        // 未绑手机号
        case 3:
            gotoBindMobile();
            break;
        // 产品宣传页面
        case 4: // 非白名单 访问home页
        case 6: // 访问/apply/status这个接口时候才会返回的未登录标识 与全局为2的不一样 因为未登录也要能访问宣传页
            if (pathName !== '/home' && pathName.indexOf('/faq') === -1 && pathName !== '/protocol/serviceprotocol') {
                history.replace('/home');
            }
            break;
        case 5: // 系统维护
            history.replace('/maintenance/apply');
            break;
        case 8: // 申请阶段维护
            if (pathName.indexOf('/apply/') === 0) {
                history.replace('/maintenance/apply');
            }
            break;
        case 9: // 提现阶段维护
            if (pathName.indexOf('/withdraw/') === 0) {
                history.replace('/maintenance/withdraw');
            }
            break;
        case 10: // 还款阶段维护
            if (pathName.indexOf('/repayment/') === 0) {
                history.replace('/maintenance/repayment');
            }
            break;
        case 7: // 微信公众号下需要认证
            window.location.replace(res.data.wxUrl || window.location.href);
            break;
        case 11: // 需要跳转到贷超，58app内所有入口会先进贷超，拦截会在贷超来做，从贷超进好借会做特殊处理，所以58app下不会走到这，不需要考虑58app的页面跳转情况
            window.location.replace(urlAddFrom(res.data.jumpUrl));
            break;
        case 12: {
            // 在API平台有一推进件的好借订单，在好借APP/H5会弹窗提示用户去58APP用信
            const tipTxt = is58App() ? '抱歉，58好借暂时无法申请，如果您已有订单，请返回，在【我的】页面查看' : '您已在58同城APP上申请过58好借，请回58同城APP上完成后续操作。';
            // 58app下页面的render有350ms的延时
            setTimeout(() => {
                !isShowTipLayer && Alert('', <p className="left-text">{tipTxt}</p>, []);
                isShowTipLayer = true;
            }, is58App() ? 450 : 0);
            break;
        }
        // 业务处理返回错误
        default:
            Toast.fail(res.msg || '系统异常，请稍后重试！');
    }
    return res;
};

export default handleResponseCode;



// WEBPACK FOOTER //
// ./src/api/ResponseCodeHandle.js